import React, { FocusEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PhoneInput from 'react-phone-input-2'
import { COMMON } from '../../_constants'
import './phoneInput.scss'

interface ICountryData {
  countryCode: string
  dialCode: string
  format: string
  name: string
}

interface IPhoneField {
  name: string
  value: string | undefined
  isValid?: boolean
  disabled?: boolean
  onBlur: (e: FocusEvent<HTMLInputElement>) => void
  onChange: (
    value: string,
    data: Record<string, never> | ICountryData,
    event: React.ChangeEvent<HTMLInputElement>,
    formattedValue: string,
  ) => void
}

interface IPhoneNumberInput {
  phoneField: IPhoneField
  style: React.CSSProperties
  isMandatory: boolean
  isoCode?: string
  disableDropdown?: boolean
}

const PhoneNumberInput = ({
  phoneField,
  style,
  isMandatory,
  isoCode,
  disableDropdown,
}: IPhoneNumberInput) => {
  const { t } = useTranslation()
  const [internalValue, setInternalValue] = useState<string | undefined>(phoneField.value)
  useEffect(() => {
    setInternalValue(phoneField.value)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phoneField.value])

  const handleChange = (
    value: string,
    data: ICountryData,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setInternalValue(value)
    phoneField.onChange(value, data, event, value)
  }

  return (
    <PhoneInput
      {...phoneField}
      value={internalValue}
      country={isoCode?.toLowerCase() || COMMON.DEFAULT_ISO_CODE}
      placeholder={t('commonComponents.phoneLabel')}
      specialLabel={`${t('commonComponents.phoneLabel')}${isMandatory ? '*' : ''} `}
      defaultErrorMessage={t('commonComponents.defaultPhoneError')}
      inputStyle={style}
      inputProps={{
        required: true,
        autoFocus: false,
      }}
      disabled={phoneField.disabled}
      disableCountryGuess
      countryCodeEditable={false}
      onChange={handleChange}
      disableDropdown={disableDropdown}
    />
  )
}

export default PhoneNumberInput
